import React, { ReactNode } from "react";
import classNames from "classnames";
import { ReactComponent as NoResultsIcon } from "../../../../assets/img/no-results.svg";
import Styles from "./NoResults.module.scss";
import Button from "../../../theme/button/Button";

export default function NoResults({
    onClear,
    text,
    title,
    resetButtonText,
    resetIcon,
    className,
}: {
    onClear?: () => void;
    text?: string;
    title?: string;
    resetButtonText?: string;
    resetIcon?: ReactNode;
    className?: string;
}) {
    return (
        <div className={classNames(Styles["no-results"], className)}>
            <NoResultsIcon />

            <h4 className={Styles.title}>{title}</h4>
            <p className={Styles["more-info"]}>
                {text}
            </p>
            {onClear && (
                <Button
                    onClick={onClear}
                    prefixIcon={resetIcon}
                    variant="outline-blue"
                >
                    {resetButtonText}
                </Button>
            )}

        </div>
    );
}

NoResults.defaultProps = {
    title: "No Results Found",
    text: "Try adjusting your search or filter to find what you are looking for.",
    resetButtonText: "Reset Filters",
    resetIcon: undefined,
    className: "",
    onClear: undefined,
};
